export function getAppletsUrl(supportLocal: boolean = true) {
  const env = import.meta.env.VITE_API_DISAMBIGUATOR ?? '';
  if (supportLocal) {
    if (env === 'localhost') {
      return `${document.location.protocol}://localhost:3010`;
    }
    if (document.location.hostname.startsWith('local.')) {
      return `https://local.getcartwheel.com:3010`;
    }
  }
  return `https://app${env}.getcartwheel.com`;
}
